import { useContext } from 'react';
import { Empty} from 'antd';

import { SessaoARContext } from '../../Contexts/SessaoContext';
import { EnumTipoUsuario } from '../../../Models/Domain/AreaRestrita/Sessao';
import { DadosCadastrais } from '../../Components/DadosCadastrais';

export const MeusDados: React.FC<{}> = (props) => {

    const SessaoAR = useContext(SessaoARContext);

    const tipoDeUsuario = SessaoAR?.sessao?.tipoDeUsuario;

    if(tipoDeUsuario == EnumTipoUsuario.Responsavel){
        return (
            <DadosCadastrais>
                <DadosCadastrais.ParaTipoResponsavel />
            </DadosCadastrais>
        )
    } else if (tipoDeUsuario == EnumTipoUsuario.Escola){
        return (
            <DadosCadastrais>
                <DadosCadastrais.ParaTipoEscola />
            </DadosCadastrais>
        )
    } 

    return <Empty/>
}
